import { render } from "./SelectedPersonAvatars.vue?vue&type=template&id=85b87f80&scoped=true&ts=true"
import script from "./SelectedPersonAvatars.vue?vue&type=script&lang=ts"
export * from "./SelectedPersonAvatars.vue?vue&type=script&lang=ts"

import "./SelectedPersonAvatars.vue?vue&type=style&index=0&id=85b87f80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85b87f80"]])

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar,QImg,QIcon,QTooltip});
